import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ba497aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Total Vote")
], -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Return Ratio")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("tr", null, [
      _hoisted_1,
      _createElementVNode("td", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.timeRemainingString), 1)
      ]),
      _hoisted_2
    ]),
    (_ctx.verbose)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
          _createElementVNode("td", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.team1TotalAlgos), 1)
          ]),
          _hoisted_4,
          _createElementVNode("td", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.team2TotalAlgos), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.verbose)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
          _createElementVNode("td", null, [
            _createElementVNode("span", null, "1:" + _toDisplayString(_ctx.team1Ratio), 1)
          ]),
          _hoisted_6,
          _createElementVNode("td", null, [
            _createElementVNode("span", null, "1:" + _toDisplayString(_ctx.team2Ratio), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}